import { useMemo, useRef } from "react";
import { GetCartListResponse } from "src/modules/api/Shop/getCartList/types";
import { useGetUserPontaPointFromCart } from "src/modules/api/Shop/getUserPontaPointFromCart";
import { useGetUserLazyData } from "src/modules/api/User/getUserLazyData/useGetUserLazyData";
import { OpenId } from "src/modules/domain/user/openId";
import { getLocalStorage } from "src/modules/localStorage";

export const useOrderPontaPoint = (cartList?: GetCartListResponse) => {
  const obtainablePontaPoint = useRef(0);
  const obtainableSmartPassPontaPoint = useRef(0);
  const pontaPointForUseResult = useMemo(() => {
    return getLocalStorage<number>("pontaPointForUse");
  }, []);
  const pontaPointForUse = useMemo(() => {
    return pontaPointForUseResult.isStored ? pontaPointForUseResult.value : 0;
  }, [pontaPointForUseResult]);
  const { data } = useGetUserLazyData();
  const isRegisteredAuId = useMemo(
    () => OpenId.isRegisteredAuId(data?.open_id_list ?? []),
    [data?.open_id_list]
  );

  const shouldFetchPontaPointInfo =
    isRegisteredAuId && typeof cartList?.active_cart?.cart_id !== "undefined";
  const { data: pontaPointData } = useGetUserPontaPointFromCart(
    {
      cart_id: cartList?.active_cart?.cart_id || 0,
      use_ponta_point: pontaPointForUse || 0,
    },
    shouldFetchPontaPointInfo
  );

  if (pontaPointData) {
    obtainablePontaPoint.current = pontaPointData.obtain_ponta_point;
    obtainableSmartPassPontaPoint.current =
      pontaPointData.obtain_smart_pass_ponta_point;
  }

  return {
    obtainablePontaPoint: obtainablePontaPoint.current,
    obtainableSmartPassPontaPoint: obtainableSmartPassPontaPoint.current,
    isRegisteredAuId,
  };
};
